import React, { useState, useEffect } from 'react';
import { StyledCard } from './index.styled';

type AppCardTabListPropsTypes<K extends string> = {
  title?: string;
  tabList: Array<{ key: K; tab: React.ReactNode; disabled?: boolean }>;
  activeTab: K;
  children?: React.ReactNode;
  handleTabChange: (key: K) => void;
  isNoBorderTop?: boolean;
  isNoBorder?: boolean;
  [x: string]: any;
};

const AppCardTabListContainer = <K extends string>({
  title,
  tabList,
  activeTab,
  children,
  handleTabChange,
  isNoBorderTop = false,
  isNoBorder = false,
  ...rest
}: AppCardTabListPropsTypes<K>) => {
  const [activeTabKey, setActiveTabKey] = useState<K>(
    tabList?.[0]?.key || ('' as K),
  );

  useEffect(() => {
    setActiveTabKey(activeTab);
  }, [activeTab]);

  const onTabChange = (key: string) => {
    handleTabChange(key as K);
  };

  return (
    <StyledCard
      variant="outlined"
      style={{ width: '100%' }}
      title={title || null}
      tabList={tabList}
      activeTabKey={activeTabKey}
      onTabChange={onTabChange}
      isNoBorderTop={isNoBorderTop}
      isNoBorder={isNoBorder}
      {...rest}
    >
      {children}
    </StyledCard>
  );
};

export default AppCardTabListContainer;
